export default class ProviderInfo {
    providerKey = null
    providerId = null
    name = null
    financingName = null
    logo = null
    altLogo = null
    footerLogo = null
    paymentCalculatorRecalculatingModal = false
    minOffersWithPrequalifiedAmount = false
    fetchPaymentPlansOnPreAuth = true
    fetchPaymentPlansOnResume = false
    publishContinueUrl = false
    subLender = null
    paymentPlanFilterOverrides = null
    selectOfferWithPrequalifiedAmount = false
    productType = null
    acceptOfferOnSelectOffer = false
    patchOnContinue = false

    constructor({
                    providerId = null,
                    name = null,
                    financingName = null,
                    logo = null,
                    altLogo = null,
                    footerLogo = null,
                    paymentCalculatorRecalculatingModal = false,
                    minOffersWithPrequalifiedAmount = false,
                    fetchPaymentPlansOnPreAuth = true,
                    fetchPaymentPlansOnResume = false,
                    publishContinueUrl = false,
                    subLender = null,
                    paymentPlanFilterOverrides = null,
                    selectOfferWithPrequalifiedAmount = false,
                    productType = null,
                    acceptOfferOnSelectOffer = false,
                    patchOnContinue = false
    }) {
        this.providerId = providerId
        this.name = name
        this.financingName = financingName
        this.logo = logo
        this.altLogo = altLogo
        this.footerLogo = footerLogo
        this.paymentCalculatorRecalculatingModal = paymentCalculatorRecalculatingModal
        this.minOffersWithPrequalifiedAmount = minOffersWithPrequalifiedAmount
        this.fetchPaymentPlansOnPreAuth = fetchPaymentPlansOnPreAuth
        this.fetchPaymentPlansOnResume = fetchPaymentPlansOnResume
        this.publishContinueUrl = publishContinueUrl
        this.subLender = subLender
        this.paymentPlanFilterOverrides = paymentPlanFilterOverrides
        this.selectOfferWithPrequalifiedAmount = selectOfferWithPrequalifiedAmount
        this.productType = productType
        this.acceptOfferOnSelectOffer = acceptOfferOnSelectOffer
        this.patchOnContinue = patchOnContinue
    }

}
